import { Button, Flex } from "@/atoms"
import { Form } from "@/organisms/Form"

export const WeekDayPicker = () => {
  const { form, custom } = Form.useForm()
  const daysValue = Form.useWatch("days", form) || {}
  const locale = navigator?.language || "en-US"
  const intl = new Intl.DateTimeFormat(locale, { weekday: "short" })
  const baseDate = new Date(2024, 0, 1)
  const days = Array(7)
    .fill(0)
    .map((_, index) => {
      const date = new Date(baseDate)

      date.setDate(baseDate.getDate() + index)

      return { index: date.getDay(), name: intl.format(date).charAt(0) }
    })
    .sort((a, b) => a.index - b.index)

  return (
    <Form.Item colon={false} label="Repeat on" name="days" layout="horizontal">
      <Flex wrap gap={12}>
        {days.map(({ index, name }) => {
          const isSelected = daysValue[index]

          return (
            <Button
              key={index}
              color={isSelected ? "primary" : "default"}
              variant={isSelected ? "solid" : "filled"}
              onClick={() => {
                form.setFieldValue("days", {
                  ...daysValue,
                  [index]: !isSelected
                })

                if (!custom.isDirty) custom.setIsDirty(true)
              }}
            >
              {name}
            </Button>
          )
        })}
      </Flex>
    </Form.Item>
  )
}
